import React from 'react';
import userCheckIcon from './user-check.png';
import { RouteComponentProps } from 'react-router-dom';
import AuthStatusPage from 'components/auth/AuthStatusPage';

const RegisterUserSuccess: React.FC<RouteComponentProps> = () => {
  return (
    <AuthStatusPage
      imageSrc={userCheckIcon}
      imageAlt="Success"
      title="You have successfully created an account!"
      message={`We have sent you an email with a link to confirm your account.\nFollow the link from the email to complete the registration.`}
    />
  );
};

export default RegisterUserSuccess;
